#import "../fragments/user-session-fragment.graphql"

query GetUserSessions($userId: ID, $first: Int, $after: String) {
    userSessions(userId: $userId, first: $first, after: $after) {
        totalCount
        pageInfo {
            startCursor
            endCursor
            hasNextPage
            hasPreviousPage
        }
        edges {
            node {
                ...UserSessionFragment
            }
        }
    }
}
